import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import { usePlantContext } from "../../../../../../../components/Drawers/TreeViewDrawer/PlantContext";

export default function SRVPage() {
  const { srvId } = useParams();
  const { plant } = usePlantContext();

  return (
    <Box>
      <PageHeader plant={plant} pageTitle="Service Requisition (SRV)" />
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          {srvId ? `SRV #${srvId}` : "Coming soon..."}
        </Typography>
      </Box>
    </Box>
  );
}
